import { render, staticRenderFns } from "./MtipocargaFormHeader.vue?vue&type=template&id=5ce42853"
import script from "./MtipocargaFormHeader.vue?vue&type=script&lang=js"
export * from "./MtipocargaFormHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports